import { OfficeWithdrawal } from '@/features/office_withdrawal';
import { FC } from 'react';

const OfficeWithdrawalPage: FC = () => {
  return <OfficeWithdrawal />;
};

export default OfficeWithdrawalPage;
